import {
  ExamCourseAnalysisReportExportButton,
  ExamCourseAnalysisReportFilterSection,
  ExamCourseAnalysisReportPageHeader,
  ExamCourseAnalysisReportTable,
} from '@report/exam-course-analysis-report';
import { APP_PERMISSIONS } from '@report/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamCourseAnalysisPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_COURSE_ANALYSIS_REPORT.VIEW}>
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <ExamCourseAnalysisReportPageHeader />
        <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
          <PaperSection
            title='รายงานวิเคราะห์ผลการสอบตามหลักสูตร'
            endAdornment={<ExamCourseAnalysisReportExportButton />}
          >
            <Flex
              sx={(theme) => ({
                p: theme.spacing(6),
                gap: theme.spacing(6),
                flexGrow: 1,
                flexDirection: 'column',
              })}
            >
              <ExamCourseAnalysisReportFilterSection />
              <ExamCourseAnalysisReportTable />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
